'use strict';

require("./TradeInController");
require("./Detail");